import cn from 'classnames';
import type { MouseEvent } from 'react';

import type { BadgeStyleParams } from '../badgeStyle';

type Props = {
  label: string;
  style?: BadgeStyleParams;
  selected?: boolean;
  disabled?: boolean;
  count?: number;
  className?: string;
  onClick?: (event: MouseEvent) => void;
  'data-testid'?: string;
};

export const Badge = ({
  label,
  style,
  selected,
  disabled,
  count,
  className,
  onClick,
  'data-testid': dataTestId
}: Props) => {
  return (
    <span
      data-testid={dataTestId}
      className={cn(
        'w-fit max-w-full overflow-hidden truncate rounded-2xl px-2 py-1 text-sm leading-4',
        className,
        style && {
          'hover:cursor-pointer': onClick && !disabled,
          'bg-transparent text-content-brand-subtle': disabled,
          [`${style.color} ${style.hover}`]: !disabled && !selected,
          [style.activeColor]: selected
        }
      )}
      onClick={onClick}
    >
      {Number.isInteger(count) && (
        <span className="mr-1 font-bold">{count}</span>
      )}
      {label}
    </span>
  );
};
